import closeDeeplink from '../utils/closeDeeplink';
import { isFeatureEnabled } from 'owa-feature-flags';
import { onCloseCompose } from 'owa-mail-actions/lib/composeActions';
import { orchestrator } from 'satcheljs';

export default orchestrator(onCloseCompose, actionMessage => {
    if (!isFeatureEnabled('rp-popoutsDebug')) {
        closeDeeplink(actionMessage.closeReason, true /*shouldNotifyOpener*/);
    }
});
